import { ApplicationConfig, provideBrowserGlobalErrorListeners, isDevMode, provideZonelessChangeDetection, ErrorHandler, importProvidersFrom, LOCALE_ID, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app-core/interceptors/auth.interceptor';
import { confirmDeleteInterceptor } from './app-core/interceptors/confirm-delete.interceptor';
import { errorCatchingInterceptor } from './app-core/interceptors/error-catching.interceptor';
import { loadingInterceptor } from './app-core/interceptors/loading.interceptor';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { ErrorService } from './app-core/services/error.service';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import OktaAuth from '@okta/okta-auth-js';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';

registerLocaleData(localePl);

const DEFAULT_LANG = localStorage.getItem('language') || 'pl-PL';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      translate.setFallbackLang(DEFAULT_LANG);
      return translate.use(DEFAULT_LANG);
    }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withViewTransitions(),
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideZonelessChangeDetection(),
    provideNativeDateAdapter(),
    provideHttpClient(withInterceptors([
      authInterceptor,
      confirmDeleteInterceptor,
      loadingInterceptor,
      errorCatchingInterceptor,
    ])),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: () => new TranslateHttpLoader(),
      }
    }),
    importProvidersFrom([
      OktaAuthModule,
    ]),
    {
      provide: ErrorHandler,
      useClass: ErrorService,
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'yyyy-MM-dd' }
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: DEFAULT_LANG
    },
    {
      provide: LOCALE_ID,
      useValue: DEFAULT_LANG
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' }
    },
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth: new OktaAuth(environment.okta) }
    },
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: { prefix: `i18n/` },
    },
  ]
};
